export const commandType = "SCHEDULE_FLY_TO_XY";
export const label = "Fly to xy";
export const isAdminOnly = true;
export const isAdvanced = true;
export const organizations = [];
